export default {"src":"/_next/static/media/CCI.04f5ccef.svg","height":18,"width":18};